var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty",class:{'is-loading': _vm.loading}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.loading)?_c('i',{staticClass:"empty-icon fa fa-spinner fa-spin"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }